import "./projects.css";
import sportsjam from "../image/sportsjam.png";
import freshmenu from "../image/freshmenu.png";
import overstock from "../image/overstock.png";
import nordstrom from "../image/nordstrom.png";
import netmeds from "../image/netmeds.png";
import socialMedia from "../image/socialMedia.png";


import { BsBoxArrowInRight } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";
import { GroupProjects } from "./GroupProjects";
import { SoloProjects } from "./SoloProjects";
import { useState } from "react";


export const Projects = () => {

    const [isSolo, setIsSolo] = useState(true);

    return (
        <div className="aboutContainer" id="projects">


            <div className="headingBtn">
                <p className="heading">Projects</p>
                <div></div>

            </div>

            <div className='proj_btn_div'>
                <button onClick={()=> setIsSolo(true)} className={isSolo? 'proj_btn_on' : 'proj_btn_off'}>Solo Projects</button>
                <button onClick={()=> setIsSolo(false)} className={isSolo? 'proj_btn_off' : 'proj_btn_on'}>Group Projects</button>
            </div>

            <div>
                { !isSolo && <GroupProjects/>}
               { isSolo && <SoloProjects/>}
            </div>




        </div>
    )
}